import styled from 'styled-components'

export const Tweet = styled.div<{ isLoaded: boolean; isRecent: boolean }>`
  width: 100%;
  position: relative;
  transform-origin: center;
  transform: scale(${(props) => (props.isLoaded ? '1' : '0.95')});
  filter: blur(${(props) => (props.isLoaded ? '0px' : '2.5px')});
  opacity: ${(props) => (props.isLoaded ? 1 : 0)};
  background-color: ${(props) => (props.isRecent ? '#f8fffc' : 'transparent')};
  top: ${(props) => (props.isLoaded ? '0px' : '-60px')};

  &.is-loaded {
    opacity: 1;
    transform: scale(1);
    filter: blur(0px);
    transition: all, 0.75s;
    -moz-transition: all, 0.75s;
    -webkit-transition: all, 0.75s;
    top: 0;
  }
`

export const TweetLozenge = styled.span`
  position: absolute;
  right: 60px;
  top: 16px;
`

export const TweetList = styled.div`
  max-height: calc(50vh);
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  padding-right: 12px;
  transition: all, 0.5s;
  -moz-transition: all, 0.5s;
  -webkit-transition: all, 0.5s;

  &::-webkit-scrollbar {
    width: 5px;
    border-radius: 20px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b5b5b5;
    border-radius: 20px;
  }
`
